import { render, staticRenderFns } from "./TaskManagementList.vue?vue&type=template&id=01ded4ca&scoped=true"
import script from "./TaskManagementList.vue?vue&type=script&lang=js"
export * from "./TaskManagementList.vue?vue&type=script&lang=js"
import style0 from "./TaskManagementList.vue?vue&type=style&index=0&id=01ded4ca&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ded4ca",
  null
  
)

export default component.exports